/**
 * @legacy
 * @extends base_common.html template
 */
import '../../ui/legacy/common'

/**
 * @legacy
 * @prev status/templates/status/base.html
 */
import 'select2/select2.css'
import '../../ui/legacy/css/select2.css'
import '../../ui/legacy/css/template_style_desktop.css'
import '../../ui/legacy/css/template_style_responsive.css'
import './css/status.css'
import './js/index.js'

document.addEventListener('DOMContentLoaded', async () => {
  const flags = JSON.parse(document.body.dataset.flags)
  /**
   * @legacy
   * @prev status/templates/status/operation_read.html
   */
  flags.highlightCode && (await import('../../ui/legacy/js/highlight.js'))
})
